import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "timePickerComponentContent RentComponent" }
const _hoisted_2 = { id: "timeParagraph" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "modal-mask" }
const _hoisted_5 = { class: "modal-wrapper" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = {
  class: "modal-header",
  id: "timePickerModalHeader"
}
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "timePickerModalText" }
const _hoisted_10 = { class: "timePickerModalInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageComponent = _resolveComponent("MessageComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      class: "timePickerComponent RentComponent position-relative",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal(true)))
    }, _ctx.$attrs), [
      (!_ctx.isValid)
        ? (_openBlock(), _createBlock(_component_MessageComponent, {
            key: 0,
            "message-class": 'error-time-message',
            message: _ctx.message
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _cache[7] || (_cache[7] = _createElementVNode("div", { id: "triangle" }, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { id: "triangleBorder" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", {
          class: _normalizeClass({'error-message-color': !_ctx.isValid})
        }, _toDisplayString(_ctx.$t('time')), 3),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.fullTime.split(':')[0]) + " : " + _toDisplayString(_ctx.fullTime.split(':')[1]), 1)
      ]),
      (_ctx.timePickerModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_Transition, { name: "timePickerModal" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "close",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal(false)), ["stop"]))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('time')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.modalTranslation), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("select", {
                            value: _ctx.currentHours.length === 1 ? '0' + _ctx.currentHours : _ctx.currentHours,
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeHours && _ctx.changeHours(...args)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: hour,
                                key: hour
                              }, _toDisplayString(hour), 9, _hoisted_12))
                            }), 128))
                          ], 40, _hoisted_11),
                          _cache[6] || (_cache[6] = _createElementVNode("span", null, ":", -1)),
                          _createElementVNode("select", {
                            value: _ctx.currentMinutes.length === 1 ? '0' + _ctx.currentMinutes : _ctx.currentMinutes,
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeMinutes && _ctx.changeMinutes(...args)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minutes, (minute) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: minute,
                                key: minute
                              }, _toDisplayString(minute), 9, _hoisted_14))
                            }), 128))
                          ], 40, _hoisted_13)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 16),
    (_ctx.timePickerModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "closeTimepickerModal",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal(false)))
        }))
      : _createCommentVNode("", true)
  ], 64))
}